import { KOLOM_SKU, kunciJenis } from "./halamanPP";
import SelKolom, { kelasRata } from "./SelKolom";

// Tabel SKU di tab Info Program — kolom per jenis dari `KOLOM_SKU` (keberatan
// jalur-layar-sisa-rumus): program Support Aktivasi tidak punya harga lama/
// baru, jadi kolom "Selisih" hari ini tampil Rp 0/NaN untuknya. Nominal per SKU
// program jenis baru datang dari backend (`nominal_sku`).
export default function TabelSkuProgram({ program }) {
  const kunci = kunciJenis({ jenis: program.jenis_efektif, mode: program.mode_efektif });
  const kolom = KOLOM_SKU[kunci];
  return (
    <div className="border border-slate-200 rounded-lg overflow-x-auto" data-testid="cb-prog-sku-tabel" data-kolom={kunci}>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase text-slate-500">
          <tr>
            {kolom.map((c) => <th key={c.kunci} className={`px-3 py-2 ${kelasRata(c)}`}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {(program.items || []).map((it) => (
            <tr key={it.sku} data-testid={`cb-prog-sku-row-${it.sku}`}>
              {kolom.map((c) => (
                <td key={c.kunci} className={`px-3 py-2 ${kelasRata(c)}`}><SelKolom kolom={c} baris={it} /></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
